import script from "./ChatComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatComponent.vue?vue&type=script&setup=true&lang=js"

import "./ChatComponent.vue?vue&type=style&index=0&id=002bdfa9&scoped=true&lang=css"
import "./ChatComponent.vue?vue&type=style&index=1&id=002bdfa9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-002bdfa9"]])

export default __exports__